import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import ClassesList from "../pages/ClassesList";
import StudentsList from "../pages/StudentsList";
import ViewStatus from "../pages/ViewStatus";
import AllSchoolsReport from "../pages/Reports/list schools";
import AllClassesReport from "../pages/Reports/list classes";
import ReportBySchool from "../pages/Reports/school";
import ReportByClass from "../pages/Reports/class";
import AllStudentsReport from "../pages/Reports/list students";
import ReportByStudent from "../pages/Reports/student";
import TestDesign from "../pages/TestDesign";
import ViewSyllabus from "../pages/ViewSyllabus";
import { useSelector } from "react-redux";
import { ADMIN } from "../constants";

const AdminRoutes = () => {
	const { isLoggedIn, userType } = useSelector((state) => state.auth);
	const navigate = useNavigate();
	if (!isLoggedIn || userType !== ADMIN) {
		navigate("/sign-in");
	}
  return (
		<Routes>
			<Route path="/test-design" element={<TestDesign />} />
			<Route path="/syllabus" element={<ViewSyllabus />} />
			<Route path="/schools/:id/classes/:id/status" element={<ViewStatus />} />
			<Route
				path="/schools/:id/classes/:id/students"
				element={<StudentsList />}
			/>
			<Route path="/schools/:id/classes" element={<ClassesList />} />
			<Route path="/dashboard" element={<Dashboard />} />
			<Route path="/report/:competitionId" element={<AllSchoolsReport />} />
			<Route
				path="/report/:competitionId/schools"
				element={<AllSchoolsReport />}
			/>
			<Route
				path="/report/:competitionId/schools/:schoolId"
				element={<ReportBySchool />}
			/>
			<Route
				path="/report/:competitionId/schools/:schoolId/classes"
				element={<AllClassesReport />}
			/>
			<Route
				path="/report/:competitionId/schools/:schoolId/classes/:classId"
				element={<ReportByClass />}
			/>
			<Route
				path="/report/:competitionId/schools/:schoolId/classes/:classId/students"
				element={<AllStudentsReport />}
			/>
			<Route
				path="/report/:competitionId/schools/:schoolId/classes/:classId/students/:studentId"
				element={<ReportByStudent />}
			/>
			<Route path="/*" element={<Navigate to="/dashboard" replace />} />
		</Routes>
	);
};

export default AdminRoutes;
